export default __webpack_public_path__ + "static/media/underline-cancel.7b4deb07.svg";